document.addEventListener('DOMContentLoaded', function() {
    // Check if popup should be shown based on conditions
    function checkAndShowPopup() {
        const affiliateCode = localStorage.getItem('affiliateCode');
        const klaviyoData = localStorage.getItem('klaviyoOnsite');
        
        // Check if Klaviyo form was previously shown or closed
        let shouldShowForm = true;
        
        // Check session storage for dismissed popups
        const sessionDismissed = sessionStorage.getItem('klaviyoPopupDismissed');
        if (sessionDismissed === 'true') {
            shouldShowForm = false;
            console.log('Popup not shown - was dismissed earlier this session');
        }
        
        if (klaviyoData) {
            try {
                const klaviyoObj = JSON.parse(klaviyoData);
                const formData = klaviyoObj.viewedForms?.modal;
                
                // Check if either form was viewed or disabled
                if (formData?.viewedForms?.XNF7F7 || formData?.disabledForms?.XNF7F7 ||
                    formData?.viewedForms?.VCdP5b || formData?.disabledForms?.VCdP5b) {
                    shouldShowForm = false;
                }
            } catch (e) {
                console.error('Error parsing Klaviyo data:', e);
            }
        }

        // Show forms based on conditions
        if (shouldShowForm) {
            if (affiliateCode === 'IDEAL') {
                if (window.innerWidth <= 768) {
                    window._klOnsite.push(['openForm', 'Tnztyz']); // Mobile IDEAL form
                } else {
                    window._klOnsite.push(['openForm', 'Uk7xyL']); // Desktop IDEAL form
                }
            } else if (!affiliateCode || affiliateCode === 'STSMD') {
                if (window.innerWidth <= 768) {
                    window._klOnsite.push(['openForm', 'VCdP5b']); // Regular mobile form
                } else {
                    window._klOnsite.push(['openForm', 'XNF7F7']); // Regular desktop form
                }
            }
        }
    }

    // Scroll trigger - show popup when user scrolls 15% of the page
    let popupTriggered = false;
    
    function handleScroll() {
        if (popupTriggered) return;
        
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
        const scrollPercentage = (scrollTop / documentHeight) * 100;
        
        if (scrollPercentage >= 15) {
            console.log('User scrolled 15% - triggering popup check');
            popupTriggered = true;
            window.removeEventListener('scroll', handleScroll);
            checkAndShowPopup();
        }
    }
    
    // Add scroll listener
    window.addEventListener('scroll', handleScroll);
    
    // Set up button click handler
    const observer = new MutationObserver((mutations) => {
        // Handle signup button
        const signUpButton = document.querySelector('button.needsclick.go3594183497');
        if (signUpButton && !signUpButton.dataset.listenerAttached) {
            signUpButton.addEventListener('click', () => {
                const emailInput = document.querySelector('input[type="email"]');
                const zipInput = document.querySelector('input[name="zip"]');
                
                if (emailInput?.value) {
                    localStorage.setItem('customerEmail', emailInput.value);
                    console.log('Email saved from button click:', emailInput.value);
                }
                
                if (zipInput?.value) {
                    localStorage.setItem('customerZip', zipInput.value);
                    console.log('Zip code saved from button click:', zipInput.value);
                }

                console.log('Button click data:', {
                    email: emailInput?.value || 'not provided',
                    zipCode: zipInput?.value || 'not provided'
                });
            });
            signUpButton.dataset.listenerAttached = 'true';
        }
        
        // Handle close buttons
        const closeButtons = document.querySelectorAll('button.klaviyo-close-form');
        closeButtons.forEach(button => {
            if (!button.dataset.listenerAttached) {
                button.addEventListener('click', (e) => {
                    console.log('Popup closed by user - storing in session');
                    sessionStorage.setItem('klaviyoPopupDismissed', 'true');
                    
                    // Actually close the Klaviyo form
                    if (window._klOnsite) {
                        window._klOnsite.push(['closeForm']);
                    }
                    
                    // Fallback: try to hide the form container directly
                    const formContainer = button.closest('[role="dialog"]');
                    if (formContainer) {
                        formContainer.style.display = 'none';
                    }
                    
                    // Prevent default behavior
                    e.preventDefault();
                    e.stopPropagation();
                });
                button.dataset.listenerAttached = 'true';
            }
        });
        
        // Handle "No thanks" button
        const allButtonsForNoThanks = document.querySelectorAll('button');
        allButtonsForNoThanks.forEach(button => {
            if (button.textContent && button.textContent.includes("No thanks") && !button.dataset.listenerAttached) {
                button.addEventListener('click', (e) => {
                    console.log('No thanks button clicked - closing popup');
                    sessionStorage.setItem('klaviyoPopupDismissed', 'true');
                    
                    // Actually close the Klaviyo form
                    if (window._klOnsite) {
                        window._klOnsite.push(['closeForm']);
                    }
                    
                    // Fallback: try to hide the form container directly
                    const formContainer = button.closest('[role="dialog"]');
                    if (formContainer) {
                        formContainer.style.display = 'none';
                    }
                    
                    // Prevent default behavior
                    e.preventDefault();
                    e.stopPropagation();
                });
                button.dataset.listenerAttached = 'true';
            }
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    // Immediate check for existing close buttons (in case form is already loaded)
    setTimeout(() => {
        const existingCloseButtons = document.querySelectorAll('button.klaviyo-close-form');
        existingCloseButtons.forEach(button => {
            if (!button.dataset.listenerAttached) {
                button.addEventListener('click', (e) => {
                    console.log('Popup closed by user - storing in session');
                    sessionStorage.setItem('klaviyoPopupDismissed', 'true');
                    
                    // Actually close the Klaviyo form
                    if (window._klOnsite) {
                        window._klOnsite.push(['closeForm']);
                    }
                    
                    // Fallback: try to hide the form container directly
                    const formContainer = button.closest('[role="dialog"]');
                    if (formContainer) {
                        formContainer.style.display = 'none';
                    }
                    
                    // Prevent default behavior
                    e.preventDefault();
                    e.stopPropagation();
                });
                button.dataset.listenerAttached = 'true';
            }
        });
        
        // Check for "No thanks" buttons
        const allButtons = document.querySelectorAll('button');
        allButtons.forEach(button => {
            if (button.textContent && button.textContent.includes("No thanks") && !button.dataset.listenerAttached) {
                button.addEventListener('click', (e) => {
                    console.log('No thanks button clicked - closing popup');
                    sessionStorage.setItem('klaviyoPopupDismissed', 'true');
                    
                    // Actually close the Klaviyo form
                    if (window._klOnsite) {
                        window._klOnsite.push(['closeForm']);
                    }
                    
                    // Fallback: try to hide the form container directly
                    const formContainer = button.closest('[role="dialog"]');
                    if (formContainer) {
                        formContainer.style.display = 'none';
                    }
                    
                    // Prevent default behavior
                    e.preventDefault();
                    e.stopPropagation();
                });
                button.dataset.listenerAttached = 'true';
            }
        });
    }, 100);

    // Add keyboard and click-outside handlers for additional close options
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
            const klaviyoForm = document.querySelector('[role="dialog"][aria-modal="true"]');
            if (klaviyoForm && klaviyoForm.style.display !== 'none') {
                console.log('Escape key pressed - closing Klaviyo popup');
                sessionStorage.setItem('klaviyoPopupDismissed', 'true');
                
                if (window._klOnsite) {
                    window._klOnsite.push(['closeForm']);
                }
                
                klaviyoForm.style.display = 'none';
            }
        }
    });

    // Click outside to close
    document.addEventListener('click', function(e) {
        const klaviyoForm = document.querySelector('[role="dialog"][aria-modal="true"]');
        if (klaviyoForm && klaviyoForm.style.display !== 'none') {
            const formContent = klaviyoForm.querySelector('form');
            if (formContent && !formContent.contains(e.target) && !e.target.closest('button.klaviyo-close-form')) {
                console.log('Clicked outside form - closing Klaviyo popup');
                sessionStorage.setItem('klaviyoPopupDismissed', 'true');
                
                if (window._klOnsite) {
                    window._klOnsite.push(['closeForm']);
                }
                
                klaviyoForm.style.display = 'none';
            }
        }
    });

    // Keep existing Klaviyo success handler as backup
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['addSubmitHandler', function(data) {
        const email = data?.email;
        const zipCode = document.querySelector('input[name="zip"]')?.value;
        
        if (email) {
            localStorage.setItem('customerEmail', email);
            console.log('Email saved from Klaviyo callback:', email);
        }
        
        if (zipCode) {
            localStorage.setItem('customerZip', zipCode);
            console.log('Zip code saved:', zipCode);
        }

        console.log('Form submission data:', {
            email: email || 'not provided',
            zipCode: zipCode || 'not provided'
        });
    }]);

    // Listen for Klaviyo form closures
    window._klOnsite.push(['addEventHandler', 'closeForm', function(data) {
        console.log('Klaviyo form closed event detected');
        sessionStorage.setItem('klaviyoPopupDismissed', 'true');
    }]);
}); 